import { ActionButtonMenu } from 'components/widgets/RenderLibraryTable/components/ActionMenu/components/ActionButtonMenu/ActionButtonMenu';
import { ActionMenuItemWithIcon } from 'components/common/ActionMenuItemWithIcon/actionMenuItemWithIcon';
import classes from 'components/widgets/RenderLibraryTable/components/ActionMenuError/ActionMenuError.module.scss';

export const ActionMenuError = ({ index, setShowModal, isFileDownload, onDownLoad }) => {
    return (
        <div className={classes.containter}>
            <ActionButtonMenu id={`threeDots_${index}`} tooltipContent={'More Actions'}>
                {isFileDownload && (
                    <ActionMenuItemWithIcon
                        handleClick={onDownLoad}
                        iconText={'Download File'}
                        iconType={'Download-icon'}
                    />
                )}

                <ActionMenuItemWithIcon
                    handleClick={() => setShowModal(true)}
                    iconText={'Delete'}
                    iconType={'delete-icon'}
                />
            </ActionButtonMenu>
        </div>
    );
};
